const navMenuData = [
    '首页',
    '企业资料',
    '数据资源',
    '数据交易大厅',
    '数据集',
    '数据地图',
    "数据服务商",
    '数据资产商学院',
    '国数探索实验室'
]
const navFooter = [
    '关于国数网',
    '招聘英才',
    '广告服务',
    '信息服务',
    '数据服务',
    "网站声明",
    '联系我们'
]
const newsList = [
    {
        text:'"数据要素X"大赛内蒙古分赛正式启动',
        date:'19:20',
        msg:'#地区新闻'
    },
    {
        text:'"数据要素X"大赛内蒙古分赛正式启动',
        date:'19:20',
        msg:'#地区新闻'
    },
    {
        text:'"数据要素X"大赛内蒙古分赛正式启动',
        date:'19:20',
        msg:'#地区新闻'
    },
    {
        text:'"数据要素X"大赛内蒙古分赛正式启动',
        date:'19:20',
        msg:'#地区新闻'
    },
    {
        text:'"数据要素X"大赛内蒙古分赛正式启动',
        date:'19:20',
        msg:'#地区新闻'
    },
    {
        text:'"数据要素X"大赛内蒙古分赛正式启动',
        date:'19:20',
        msg:'#地区新闻'
    },
    {
        text:'"数据要素X"大赛内蒙古分赛正式启动',
        date:'19:20',
        msg:'#地区新闻'
    },
    {
        text:'"数据要素X"大赛内蒙古分赛正式启动',
        date:'19:20',
        msg:'#地区新闻'
    },
    {
        text:'"数据要素X"大赛内蒙古分赛正式启动',
        date:'19:20',
        msg:'#地区新闻'
    },
    {
        text:'"数据要素X"大赛内蒙古分赛正式启动',
        date:'19:20',
        msg:'#地区新闻'
    },
    {
        text:'"数据要素X"大赛内蒙古分赛正式启动',
        date:'19:20',
        msg:'#地区新闻'
    }
    
]
const detailData = [
    {
        img:require('@/assets/images/002.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        teacher:'旭栋',
        company:'旭栋湿莎紫股份有限公司',
        supplier:'旭栋湿莎紫提供',
        date:'2029-09-21',
        tips:'直播中'
    },
    {
        img:require('@/assets/images/002.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        teacher:'旭栋',
        company:'旭栋湿莎紫股份有限公司',
        supplier:'旭栋湿莎紫提供',
        date:'2029-09-21',
        tips:'即将直播'
    },
    {
        img:require('@/assets/images/002.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        teacher:'旭栋',
        company:'旭栋湿莎紫股份有限公司',
        supplier:'旭栋湿莎紫提供',
        date:'2029-09-21',
        tips:'即将直播'
    },
    {
        img:require('@/assets/images/002.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        teacher:'旭栋',
        company:'旭栋湿莎紫股份有限公司',
        supplier:'旭栋湿莎紫提供',
        date:'2029-09-21',
        tips:'即将直播'
    }
    
]
const newsDetailData = [
    {
        img:require('@/assets/images/003.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        text:'为贯彻落实金铲铲对武则天英雄的考虑,我们将武则天技能改为每秒给我银行卡打钱,并且全年全天每时每刻无休,九级后打钱金额翻倍,速度翻倍,事实到账,当然也对武则天进行削弱,移除旭栋霸符等,并且每天对旭栋进行精神攻击,不定时攻击,想攻击就攻击文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑',
        area:'内蒙古自治区'
    },
    {
        img:require('@/assets/images/003.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        text:'为贯彻落实金铲铲对武则天英雄的考虑,我们将武则天技能改为每秒给我银行卡打钱,并且全年全天每时每刻无休',
        area:'内蒙古自治区'
    },
    {
        img:require('@/assets/images/003.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        text:'为贯彻落实金铲铲对武则天英雄的考虑,我们将武则天技能改为每秒给我银行卡打钱,并且全年全天每时每刻无休,九级后打钱金额翻倍,速度翻倍,事实到账,当然也对武则天进行削弱,移除旭栋霸符等,并且每天对旭栋进行精神攻击,不定时攻击,想攻击就攻击文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑',
        area:'内蒙古自治区'
    },
    {
        img:require('@/assets/images/003.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        text:'为贯彻落实金铲铲对武则天英雄的考虑,我们将武则天技能改为每秒给我银行卡打钱,并且全年全天每时每刻无休,九级后打钱金额翻倍,速度翻倍,事实到账,当然也对武则天进行削弱,移除旭栋霸符等,并且每天对旭栋进行精神攻击,不定时攻击,想攻击就攻击文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑',
        area:'内蒙古自治区'
    },    {
        img:require('@/assets/images/003.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        text:'为贯彻落实金铲铲对武则天英雄的考虑,我们将武则天技能改为每秒给我银行卡打钱,并且全年全天每时每刻无休,九级后打钱金额翻倍,速度翻倍,事实到账,当然也对武则天进行削弱,移除旭栋霸符等,并且每天对旭栋进行精神攻击,不定时攻击,想攻击就攻击,文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑',
        area:'内蒙古自治区'
    },
    {
        img:require('@/assets/images/003.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        text:'为贯彻落实金铲铲对武则天英雄的考虑,我们将武则天技能改为每秒给我银行卡打钱,并且全年全天每时每刻无休,九级后打钱金额翻倍,速度翻倍,事实到账,当然也对武则天进行削弱,移除旭栋霸符等,并且每天对旭栋进行精神攻击,不定时攻击,想攻击就攻击,文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑',
        area:'内蒙古自治区'
    },
    {
        img:require('@/assets/images/003.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        text:'为贯彻落实金铲铲对武则天英雄的考虑,我们将武则天技能改为每秒给我银行卡打钱,并且全年全天每时每刻无休,九级后打钱金额翻倍,速度翻倍,事实到账,当然也对武则天进行削弱,移除旭栋霸符等,并且每天对旭栋进行精神攻击,不定时攻击,想攻击就攻击,文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑',
        area:'内蒙古自治区'
    },
    {
        img:require('@/assets/images/003.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        text:'为贯彻落实金铲铲对武则天英雄的考虑,我们将武则天技能改为每秒给我银行卡打钱,并且全年全天每时每刻无休,九级后打钱金额翻倍,速度翻倍,事实到账,当然也对武则天进行削弱,移除旭栋霸符等,并且每天对旭栋进行精神攻击,不定时攻击,想攻击就攻击,文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑',
        area:'内蒙古自治区'
    },
    {
        img:require('@/assets/images/003.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        text:'为贯彻落实金铲铲对武则天英雄的考虑,我们将武则天技能改为每秒给我银行卡打钱,并且全年全天每时每刻无休,九级后打钱金额翻倍,速度翻倍,事实到账,当然也对武则天进行削弱,移除旭栋霸符等,并且每天对旭栋进行精神攻击,不定时攻击,想攻击就攻击,文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑',
        area:'内蒙古自治区'
    },
    {
        img:require('@/assets/images/003.jpg'),
        title:'数据要素X"大赛内蒙古分赛正式启动',
        text:'为贯彻落实金铲铲对武则天英雄的考虑,我们将武则天技能改为每秒给我银行卡打钱,并且全年全天每时每刻无休,九级后打钱金额翻倍,速度翻倍,事实到账,当然也对武则天进行削弱,移除旭栋霸符等,并且每天对旭栋进行精神攻击,不定时攻击,想攻击就攻击,文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑旭栋来凑文字不够,旭栋来凑',
        area:'内蒙古自治区'
    }
]
const userDetailData = [
    {
        img:require('@/assets/images/004.jpg'),
        label:'数据人物',
        name:'旭栋',
        position:'研究酒文化和美女专家',
        characterIntroduction:'赵旭东,男,年级不详,少女杀手(10-16岁),一生专注于此领域,对此领域少女颇有研究,外号少女杀手.著名著作<<不是少女我不爱>>,<<只为少女而生>>,<<我只喜欢小的>>等,2024年后对此项研究更为深厚的赵老师,又有新的方向,对此不在剧透,尽情期待.'
    },
    {
        img:require('@/assets/images/004.jpg'),
        label:'数据人物',
        name:'旭栋',
        position:'研究酒文化和美女专家',
        characterIntroduction:'赵旭东,男,年级不详,少女杀手(10-16岁),一生专注于此领域,对此领域少女颇有研究,外号少女杀手.著名著作<<不是少女我不爱>>,<<只为少女而生>>,<<我只喜欢小的>>等,2024年后对此项研究更为深厚的赵老师,又有新的方向,对此不在剧透,尽情期待.'
    },   {
        img:require('@/assets/images/004.jpg'),
        label:'数据人物',
        name:'旭栋',
        position:'研究酒文化和美女专家',
        characterIntroduction:'赵旭东,男,年级不详,少女杀手(10-16岁),一生专注于此领域,对此领域少女颇有研究,外号少女杀手.著名著作<<不是少女我不爱>>,<<只为少女而生>>,<<我只喜欢小的>>等,2024年后对此项研究更为深厚的赵老师,又有新的方向,对此不在剧透,尽情期待.'
    }
]
export default {
    navMenuData,
    newsList,
    detailData,
    newsDetailData,
    userDetailData,
    navFooter
}